import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { queryString } from '@qadra/frontend-common';
import { FlexWrapper, SPACINGS} from "@qadra/frontend-common-ts";
import { Button, Card, Alert, Form, FormInput } from '@qadra/frontend-common/atoms';
import { Row, Col } from '@qadra/frontend-common/grid';
import { connect, push } from '@qadra/frontend-common/redux';
import { validations } from '@qadra/frontend-common/validations';
import { Heading } from '@qadra/frontend-common/typography';
import { monitoring } from '@qadra/frontend-common/tracking';
import { PASSWORD_RESET } from '../redux/actions';
import { paths } from '../utils';
import { withTranslate } from '../utils/translations';

class PasswordReset extends Component {
  constructor(props) {
    super(props);
    const { userId, code } = queryString.parse(this.props.location.search);
    this.state = {
      userId,
      code,
    };
  }

  componentDidMount() {
    if (!this.state.userId || !this.state.code) {
      monitoring.captureMessage('No code or userId in PasswordReset page', {
        contexts: { userId: this.state.userId, code: this.state.code },
      });
      this.gotoLogin();
    }
  }

  doCreatePass = ({ Password, ConfirmPassword }) => {
    this.props.onSendPass({
      Password,
      ConfirmPassword,
      Code: this.state.code,
      UserId: this.state.userId,
    });
  };

  gotoLogin = () => this.props.pushUrl(paths.login);

  validate = ({ Password, ConfirmPassword }) =>
    Password !== ConfirmPassword
      ? { ConfirmPassword: this.props.t('sso.activate.passNotMatch') }
      : {};

  render() {
    const { t, error, passSent } = this.props;
    return (
      <>
        {error && (
          <Alert style={{ marginBottom: 50 }} color="danger">
            {error}
          </Alert>
        )}
          <Card style={{ width: '100%', maxWidth:"600px", marginBottom: 0, border: 'none' }}>
            <Row>
              <Col xs={12}>
                <FlexWrapper style={{width: '100%', marginBottom: SPACINGS[12]}} justify='center'>
                  <Heading type={2}>
                    {passSent ? t('sso.passReset.titleSuccess') : t('sso.passReset.title')}
                  </Heading>
                </FlexWrapper>
              </Col>
              {passSent && (
                <Col xs={12}>
                  <p className="text-center">{t('sso.passReset.subTitleSuccess')}</p>
                </Col>
              )}
            </Row>
            {!passSent && (
              <Row>
                <Col>
                  <Form
                    innerRef={(r) => (this.form = r)}
                    validate={this.validate}
                    onSubmit={this.doCreatePass}
                  >
                    <FormInput
                      label="Password"
                      name="Password"
                      type="password"
                      small={t('sso.passReset.createPassHint')}
                      initialValue=""
                      required
                      pattern={validations.password.reg}
                      patternErr={validations.password.error}
                    />
                    <FormInput
                      label={t('sso.passReset.confirmPass')}
                      name="ConfirmPassword"
                      type="password"
                      initialValue=""
                      required
                    />
                  </Form>
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12}>
                <FlexWrapper style={{width: '100%', marginTop: SPACINGS[30]}} justify='center'>
                  <Button
                      style={{width: '300px', paddingLeft: '110px'}}
                    label={passSent ? t('sso.passReset.buttonSuccess') : t('sso.passReset.button')}
                    onClick={passSent ? this.gotoLogin : () => this.form.submitForm()}
                  />
                </FlexWrapper>
              </Col>
            </Row>
          </Card>
      </>
    );
  }
}

PasswordReset.propTypes = {
  location: PropTypes.object,
  onSendPass: PropTypes.func,
  pushUrl: PropTypes.func,
  error: PropTypes.string,
  passSent: PropTypes.bool,
};

export default withTranslate(
  connect(
    (state) => ({
      location: state.router.location,
      error: state.forgot.error,
      passSent: state.forgot.passSent,
    }),
    (dispatch) => ({
      pushUrl: (url) => dispatch(push(url)),
      onSendPass: (payload) =>
        dispatch({
          type: PASSWORD_RESET._REQUEST,
          payload,
        }),
    })
  )(PasswordReset)
);
